import { render, staticRenderFns } from "./PlayerField.vue?vue&type=template&id=2a22e8f0&"
import script from "./PlayerField.vue?vue&type=script&lang=js&"
export * from "./PlayerField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports